import { render, staticRenderFns } from "./RecurringPaymentsIframe.vue?vue&type=template&id=b8b827d6&"
import script from "./RecurringPaymentsIframe.vue?vue&type=script&lang=ts&"
export * from "./RecurringPaymentsIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports